class Navigation {

    constructor() {

        this.html = document.querySelector("html");
        this.navigation = document.querySelector(".c-navigation");
        this.toggleButton = this.navigation.querySelector(".c-main-navigation__burger--button");
        this.menuTogglers = this.navigation.querySelectorAll(".js-nav_toggler");
        this.subMenuLinks = this.navigation.querySelectorAll(".nav_submenuLink");

        this.init();
    }

    init() {
        if (!this.navigation.classList.contains("neos-backend-folder-page")) {
            this.toggleButton.addEventListener("click", (e) => {
                e.preventDefault();
                this.html.classList.toggle("nav-menu-open");
            });

            // Add submenu toggle functionality
            this.initSubmenuTogglers();
            this.closeOverlayAfterClick();
        }
    }

    initSubmenuTogglers() {
        this.menuTogglers.forEach(toggler => {
            toggler.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                const targetId = toggler.getAttribute("data-target");
                if (targetId) {
                    const submenu = document.querySelector(targetId);
                    if (submenu) {
                        // Toggle the submenu visibility
                        submenu.classList.toggle("is-open");

                        // Toggle the toggler state
                        toggler.classList.toggle("is-open");

                        // Close other open submenus
                        this.closeOtherSubmenus(targetId);
                    }
                }
            });
        });

        // Prevent submenu toggle when clicking on menu links
        const menuLinks = this.navigation.querySelectorAll(".nav_menuLink");
        menuLinks.forEach(link => {
            link.addEventListener("click", (e) => {
                e.stopPropagation();
                // Let the link work normally, don't prevent default
            });
        });
    }

    closeOtherSubmenus(currentTargetId) {
        this.menuTogglers.forEach(toggler => {
            const targetId = toggler.getAttribute("data-target");
            if (targetId && targetId !== currentTargetId) {
                const submenu = document.querySelector(targetId);
                if (submenu) {
                    submenu.classList.remove("is-open");
                    toggler.classList.remove("is-active");
                }
            }
        });
    }

    closeOverlayAfterClick() {
        this.subMenuLinks.forEach(link => {
            link.addEventListener("click", (e) => {
                console.log('closeOverlayAfterClick');
                this.html.classList.toggle("nav-menu-open");
            });
        });
    }
}

const navigation = new Navigation();